/* /tilbud – Kvitebergs tilbud til LOS Marine som en offentlig side (uten innlogging). Norsk. */
import { LOS_MARINE_NO } from "../data/tilbod/losMarine";
import { ProductProposal } from "../components/proposal/ProductProposal";
import "../proposal.css";

export default function TilbudProposalPage() {
  return <ProductProposal d={LOS_MARINE_NO} />;
}
